export default "__VITE_ASSET__CUNMe_WT__"